// File: frontend/src/components/AutoLogout/AutoLogoutWrapper.js

import { useAutoLogout } from '../../hooks/useAutoLogout';

const AutoLogoutWrapper = ({ children }) => {
  useAutoLogout();
  return children;
};

export default AutoLogoutWrapper;